import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatInputModule } from "@angular/material/input";

import { TranslocoModule } from "@jsverse/transloco";
import { NgApexchartsModule } from "ng-apexcharts";

import { LorenLineChartComponent } from "./components/loren-line-chart/loren-line-chart.component";
import { LorenChartNoteDialog } from "./components/loren-chart-note-dialog/loren-chart-note-dialog.component";
import { LorenDateModule } from "../../pipes/loren-date/loren-date.module";

@NgModule({
  declarations: [],
  exports: [],
  imports: [
    CommonModule,
    FormsModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    NgApexchartsModule,
    TranslocoModule,
    MatDialogModule,
    LorenDateModule,
    LorenLineChartComponent,
    LorenChartNoteDialog,
  ],
})
export class LorenLineChartModule {}
